export default __webpack_public_path__ + "static/media/flow.f673647b.svg";